<template>
  <div :class="componentClassName">
    <loading :active="isLoading" :is-full-page="false" :height="30" :width="30"></loading>
    <div v-if="fullscreenState && !isAcw" class="o-sf-calling-modal__setting">
      <a-calling-action-button
        v-if="!isEnded"
        icon="gear"
        popup-position="bottom"
        :activated="isSettingActionOpened"
        :popup="isSettingActionOpened"
        :handle-action-button-click="handleSettingActionButtonClick"
      >
        <template #popup>
          <form @submit.prevent="handleTransferCallPopupSubmit">
            <m-form-input label="マイク">
              <a-select-field
                v-model="currentMicrophone"
                :options="microphoneListOptions"
                placeholder="選択してください"
                @change="handleMicrophoneSelectionChange"
              />
            </m-form-input>
            <m-form-input label="スピーカー">
              <a-select-field
                v-model="currentSpeaker"
                :options="speakerListOptions"
                placeholder="選択してください"
                @change="handleSpeakerSelectionChange"
              />
            </m-form-input>
          </form>
        </template>
      </a-calling-action-button>
    </div>
    <div v-if="fullscreenState && !isEnded" class="o-sf-calling-modal__minimize">
      <a-button
        variant="icon"
        icon="minimize"
        icon-color="white"
        color="primary"
        class="o-sf-calling-modal__minimize-button"
        @click="handleMinimizeButtonClick"
      />
    </div>
    <div class="o-sf-calling-modal__controls">
      <div class="o-sf-calling-modal__caller-info">
        <a-sf-calling-customer-info
          v-if="customerInfo"
          :minimized="!fullscreenState"
          :title="customerInfo.title"
          :display-name="displayName"
          :phone-number="customerInfo.phoneNumber"
          :subtitle="customerInfo.subtitle"
        />
        <div v-if="fullscreenState" class="o-sf-calling-modal__caller-info-status">
          <a-sf-calling-status
            v-if="!isAcw"
            :status="callingStatus"
            :minimized="!fullscreenState"
            :pb-setting-name="pushNumberSettingName"
            :time="callingTime"
          />
          <a-sf-calling-status
            v-if="isAcw"
            :status="'ended'"
            :minimized="!fullscreenState"
            :pb-setting-name="pushNumberSettingName"
            :time="callingTime"
          />
        </div>
        <div v-if="!fullscreenState" class="o-sf-calling-modal__caller-info-status-minimized">
          <a-sf-calling-status
            v-if="!isAcw"
            :status="callingStatus"
            :minimized="!fullscreenState"
            :pb-setting-name="pushNumberSettingName"
            :time="callingTime"
          />
          <a-sf-calling-status
            v-if="isAcw"
            :status="'ended'"
            :minimized="!fullscreenState"
            :pb-setting-name="pushNumberSettingName"
            :time="callingTime"
          />
        </div>

        <div
          v-if="fullscreenState && (telNumberInfo || pushNumberSettingName || outgoingTelNumber)"
          class="o-sf-calling-modal__response-status"
        >
          <a-calling-response-status v-if="myInfoList.length" :status-list="myInfoList" />
        </div>

        <div v-if="!isEnded && fullscreenState" class="o-sf-calling-modal__caller-actions">
          <m-button-container variant="horizontal">
            <!-- <a-button
              variant="round"
              size="small"
              icon="phone-call-history-outline"
              icon-color="black"
              label="発着信履歴"
              @click="handleCallHistoryButtonClick"
            /> -->
            <!-- <a-button
              v-if="customerInfo.title"
              variant="round"
              size="small"
              icon="list-outline"
              icon-color="black"
              label="連絡先情報"
              @click="handleContactListButtonClick"
            /> -->
          </m-button-container>
        </div>
      </div>
      <div class="o-sf-calling-modal__actions">
        <div v-if="!isAcw" class="o-sf-calling-modal__pending-agents">
          <m-calling-pending-agents
            v-if="!isEnded"
            ref="callingPendingAgents"
            v-model="callingPendingAgents"
            :active-id="pendingActiveId"
            :available-list="pendingAvailableList"
            :minimized="!fullscreenState"
            :is-visible="!isHoldCountExceeded && !isReachHoldCountMax"
            :is-confirmation-ok="parkHoldConfirm"
            :current-memo="currentMemo"
            :should-disabled="shouldDisableParkHoldButton"
            @onhold:activated="handleOnholdActivated"
            @onhold:deactivated="handleOnholdDeactivated"
            @modal:show="handlePendingAgentsModal"
          />
        </div>
        <div v-if="!isEnded && fullscreenState && !isAcw" class="o-sf-calling-modal__actions-list">
          <m-calling-action-button-list>
            <a-calling-action-button
              label="保留"
              icon="phone-call-onhold"
              :activated="isHolding"
              :handle-action-button-click="handleHoldActionButtonClick"
              :disabled="shouldDisableHoldingButton"
              :is-visible="!isHoldCountExceeded && !isReachHoldCountMax"
            />
            <a-calling-action-button
              label="転送"
              icon="phone-call-transfer"
              :activated="isTransferActionOpened"
              :popup="isTransferActionOpened"
              :handle-action-button-click="handleTransferActionButtonClick"
              :disabled="shouldDisableTransferButton"
              :is-visible="!isTransferCountExceeded && !isReachTransferCountMax"
            >
              <template #popup>
                <form @submit.prevent="handleTransferCallPopupSubmit">
                  <m-form-input label="転送先方法">
                    <a-select-field
                      id="transferMethodOptions"
                      v-model="currentTransferMethod"
                      :options="transferMethodOptions"
                    />
                  </m-form-input>
                  <template v-if="currentTransferMethod === 'user'">
                    <m-form-input label="ユーザー選択">
                      <a-select-field
                        v-model="currentForwardingUser"
                        :options="forwardingUserList"
                        :searchable="true"
                        placeholder="ユーザー選択"
                      />
                    </m-form-input>
                  </template>
                  <template v-if="currentTransferMethod === 'phone_number'">
                    <m-form-input label="電話番号">
                      <a-text-field
                        v-model="currentTransferPhoneNumber"
                        type="text"
                        placeholder="0312345678"
                        pattern="^[0-9]+$"
                      />
                    </m-form-input>
                    <m-form-input label="発信元番号">
                      <a-select-field
                        id="o-outgoing-call-modal-select-number-transfer-modal"
                        v-model="selectedTelNumber"
                        :options="telNumberListOptions"
                      />
                    </m-form-input>
                  </template>
                  <div class="o-sf-calling-modal__popup-form-actions">
                    <a-button
                      class="o-sf-calling-modal__popup-form-cancel-button"
                      variant="round"
                      size="small"
                      label="キャンセル"
                      @click="handleCancelTransferNumberPopup"
                    />
                    <a-button
                      class="o-sf-calling-modal__popup-form-submit-button"
                      submit="submit"
                      variant="round"
                      size="small"
                      color="primary"
                      label="呼び出す"
                      :disabled="
                        (currentTransferMethod === 'user' && !currentForwardingUser) ||
                        (currentTransferMethod === 'phone_number' &&
                          (selectedTelNumber === UNSELECTED ||
                            !currentTransferPhoneNumber ||
                            ![10, 11].includes(currentTransferPhoneNumber.length)))
                      "
                    />
                  </div>
                </form>
              </template>
            </a-calling-action-button>
            <a-sf-calling-action-button
              label="ダイヤル"
              icon="numpad"
              :activated="isNumpadActionOpened"
              :popup="isNumpadActionOpened"
              :handle-action-button-click="handleNumpadActionButtonClick"
              :disabled="shouldDisableNumpadButton"
            >
              <template #popup>
                <m-numpad class="o-sf-calling-modal__numpad" @click="handleNumpadClick" />
              </template>
            </a-sf-calling-action-button>
          </m-calling-action-button-list>
        </div>
        <div v-if="!isEnded && fullscreenState" class="o-sf-calling-modal__end-button">
          <a-calling-action-button
            v-if="!isAcw"
            variant="round"
            label="通話終了"
            icon="phone-hang-up-call"
            :activated="isEndCallActionOpened"
            :popup="isEndCallActionOpened"
            :handle-action-button-click="handleEndCallActionButtonClick"
          >
            <template #popup>
              <a-button variant="round" color="primary-red" label="通話を終了する" @click="handleEndCall" />
            </template>
          </a-calling-action-button>
          <div v-if="isAcw" class="o-sf-calling-modal__close-button">
            <a-button
              variant="block"
              color="primary"
              submit="submit"
              size="medium"
              label="メモを保存して終了"
              @click="checkMemoData"
            />
          </div>
        </div>
        <div v-if="fullscreenState" class="o-sf-calling-modal__memo">
          <div class="m-form-input">
            <label class="m-form-input__label o-sf-calling-modal__memo__label">
              メモ （オペレータ名表示以外の残り文字数: {{ countWordsMemo }}文字)
              <a-icon icon="help-outline" color="black" @click="openCurrentMemoHelp" />
            </label>
            <div class="m-form-input__content o-sf-calling-modal__memo__textarea">
              <div class="a-text-field a-text-field--text">
                <textarea
                  v-model="currentMemo"
                  class="a-text-field__input o-sf-calling-modal__memo__textarea-field"
                  :maxlength="maxMemoLength"
                  placeholder="メモはオペレータ名表示を含めて1000文字以内で入力してください。"
                />
              </div>
            </div>
          </div>
          <div class="m-form-input">
            <label class="m-form-input__label o-sf-calling-modal__memo__label">
              過去に保存されたメモ （{{ countWordsSavedMemo }}文字）
              <a-icon icon="help-outline" color="black" @click="openPreviousMemoHelp" />
            </label>
            <div class="m-form-input__content o-sf-calling-modal__memo__textarea">
              <div class="a-text-field a-text-field--text">
                <textarea
                  v-model="currentSavedMemo"
                  class="a-text-field__input o-sf-calling-modal__memo__textarea-field"
                  readonly
                  placeholder="※過去に転送元ユーザー等がメモを保存していた場合は、その内容が表示されます。"
                />
              </div>
            </div>
          </div>
          <div class="o-sf-calling-modal__end-button">
            <div class="o-sf-calling-modal__update-button" style="white-space: pre-wrap">
              <a-button
                variant="block"
                color="primary"
                size="small"
                label="過去メモを更新"
                @click="handleGetSavedMemo"
              />
            </div>
          </div>
        </div>
        <div v-if="!isEnded && fullscreenState && sfAvailable" class="o-sf-calling-modal__sfinfo">
          <div class="o-sf-calling-modal__sfinfo__description">
            <a-text v-if="sfTable === 'Case'">過去のSalesforceケース</a-text>
            <a-text v-if="sfTable === 'Task'">過去のSalesforce活動履歴</a-text>
            <m-data-table
              :empty-text="'履歴はありません。'"
              :fit="true"
              :data="sfCurrentInfo.sfCases"
              class="o-sf-calling-modal__sfinfo__table"
            >
              <a-data-table-column label="件名" align="left">
                <template #default="scope">
                  <a-button :href="scope.row.sfRecordUrl" :target="'_blank'" :type="text" :color="primary">
                    {{ scope.row.sfSubject }}
                  </a-button>
                </template>
              </a-data-table-column>
              <a-data-table-column prop="CreatedDateStr" label="日時" align="left" />
              <a-data-table-column prop="sfOperator" label="対応オペレータ名" align="left" />
            </m-data-table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isEnded" class="o-sf-calling-modal__hangup-button">
      <a-button
        variant="icon"
        icon="fullscreen"
        icon-color="white"
        color="white"
        class="o-sf-calling-modal__fullscreen-button"
        @click="handleFullscreenButtonClick"
      />
      <div
        v-if="!isEnded && !isAcw"
        v-show="!isHoldCountExceeded && !isReachHoldCountMax"
        class="o-sf-calling-modal__actions-onhold"
      >
        <a-button
          variant="icon"
          icon="phone-call-onhold"
          :icon-color="isHolding ? 'white' : 'orange'"
          :class="actionOnholdButtonClassName"
          :disabled="shouldDisableHoldingButton"
          @click="handleHoldActionButtonClick"
        />
      </div>
      <a-calling-action-button
        v-if="!isEnded && !isAcw"
        variant="icon"
        icon="phone-hang-up-call"
        :activated="isEndCallActionOpened"
        :popup="isEndCallActionOpened"
        :popup-position="'bottom'"
        :handle-action-button-click="handleEndCallActionButtonClick"
      >
        <template #popup>
          <a-button
            class="o-sf-calling-modal__minimized-hangup-button"
            variant="round"
            color="primary-red"
            label="通話を終了する"
            @click="handleEndCall"
          />
        </template>
      </a-calling-action-button>
    </div>
    <o-modal
      id="sfCallingModal_resultModal"
      :visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          v-if="modalSelectable && (modalMode === 'hold' || modalMode === 'transfer' || modalMode === 'parkHold')"
          variant="block"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCloseModal"
        />
        <a-button
          v-if="modalSelectable && (modalMode === 'hold' || modalMode === 'transfer' || modalMode === 'parkHold')"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleAcceptModal"
        />
        <a-button
          v-if="modalSelectable && modalMode === 'saveMemo'"
          variant="block"
          color="primary"
          label="現在のメモ"
          size="small"
          @click="saveNewMemo"
        />
        <a-button
          v-if="modalSelectable && modalMode === 'saveMemo'"
          variant="block"
          color="primary"
          label="過去のメモ"
          size="small"
          @click="savePreviousMemo"
        />
        <a-button
          v-if="modalSelectable && modalMode === 'saveMemo'"
          variant="outlined"
          color="primary"
          label="キャンセル"
          size="small"
          @click="handleCloseModal"
        />
        <a-button
          v-if="!modalSelectable"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import ASfCallingStatus from '@/components/atoms/sf-calling-status';
import ASfCallingCustomerInfo from '@/components/atoms/sf-calling-customer-info';
import MCallingPendingAgents from '@/components/molecules/calling-pending-agents';
import ACallingResponseStatus from '@/components/atoms/calling-response-status';
import MButtonContainer from '@/components/molecules/button-container';
import MCallingActionButtonList from '@/components/molecules/calling-action-button-list';
import ACallingActionButton from '@/components/atoms/calling-action-button';
import ASfCallingActionButton from '@/components/atoms/sf-calling-action-button';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import ASelectField from '@/components/atoms/select-field';
import MUserSelectionTable from '@/components/molecules/user-selection-table';
import ACheckbox from '@/components/atoms/checkbox';
import MNumpad from '@/components/molecules/numpad';
import Simplebar from 'simplebar';
import { cloneDeep } from 'lodash';
import Loading from 'vue-loading-overlay';

import { customRequest } from '@/common/customRequest.js';
import { customValidate } from '@/common/customValidate.js';
import { messageContent } from '@/common/messageContent.js';
import { chkTrialCompanyID } from '@/libs/utils';
import { utils } from '@/common/utils.js';
const UNSELECTED = 'unselected';

export default {
  name: 'o-sf-calling-modal',
  components: {
    ASfCallingStatus,
    ASfCallingCustomerInfo,
    MCallingPendingAgents,
    ACallingResponseStatus,
    MButtonContainer,
    MCallingActionButtonList,
    ACallingActionButton,
    ASfCallingActionButton,
    AButton,
    MFormInput,
    ATextField,
    ASelectField,
    //MUserSelectionTable,
    //ACheckbox,
    MNumpad,
    Loading,
  },
  mixins: [customRequest, customValidate, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
    isFullscreen: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: 'active',
      validator(value) {
        return value.match(/(active|onhold|holdexceed|transfer|transfering|ended)/);
      },
    },
    callingTime: {
      type: String,
      default: '',
    },
    customerInfo: {
      type: Object,
      default: null,
    },
    responseStatusList: {
      type: Array,
      default: new Array(0),
    },
    pendingActiveId: {
      type: String,
      default: null,
    },
    pendingAvailableList: {
      type: Array,
      default: new Array(0),
    },
    memo: {
      type: String,
      default: '',
    },
    memoUpdated: {
      type: Boolean,
      default: false,
    },
    userList: {
      type: Array,
      default: new Array(0),
    },
    forwardingUserList: {
      type: Array,
      default: new Array(0),
    },
    microphone: {
      type: String,
      default: null,
    },
    microphoneListOptions: {
      type: Array,
      default: new Array(0),
    },
    handleMicrophoneSelectionChange: {
      type: Function,
      default: () => {},
    },
    speaker: {
      type: String,
      default: null,
    },
    speakerListOptions: {
      type: Array,
      default: new Array(0),
    },
    companyID: {
      type: String,
      required: true,
    },
    handleSpeakerSelectionChange: {
      type: Function,
      default: () => {},
    },
    handleCallHistoryButtonClick: {
      type: Function,
      default: () => {},
    },
    handleContactListButtonClick: {
      type: Function,
      default: () => {},
    },
    handleHoldButtonClick: {
      type: Function,
      default: () => {},
    },
    handleTransferAgentButtonClick: {
      type: Function,
      default: () => {},
    },
    handleEndCallButtonClick: {
      type: Function,
      default: () => {},
    },
    handleNumpadClick: {
      type: Function,
      default: () => {},
    },
    handleTransferCallSubmit: {
      type: Function,
      default: () => {},
    },
    handleEndFormSubmit: {
      type: Function,
      default: () => {},
    },
    handleOnholdActivateButtonClick: {
      type: Function,
      default: () => {},
    },
    handleOnholdDeactivateButtonClick: {
      type: Function,
      default: () => {},
    },
    isTransferCountExceeded: {
      type: Boolean,
      default: false,
    },
    isHoldCountExceeded: {
      type: Boolean,
      default: false,
    },
    isTransferOk: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    pushNumberSettingName: {
      type: String,
      default: '',
    },
    currentUserInfo: {
      type: Object,
      default: null,
    },
    isAcw: {
      type: Boolean,
      default: false,
    },
    handleCloseCall: {
      type: Function,
      default: () => {},
    },
    createdCaseId: {
      type: String,
      default: '',
    },
    sfCurrentInfo: {
      type: Object,
      default: null,
    },
    telNumberInfo: {
      type: Object,
      default: null,
    },
    currentCallSid: {
      type: String,
      default: '',
    },
  },
  emits: ['update-client-list', 'update-calling-modal-fullscreen', 'update-memo-empty-status', 'sync-memo'],
  data() {
    return {
      fullscreenState: false,
      isSettingActionOpened: false,
      isActive: false,
      isHolding: false,
      isTransfer: false,
      isParkHolding: false,
      isTransferActionOpened: false,
      isNumpadActionOpened: false,
      isEndCallActionOpened: false,
      currentMemo: '',
      sharedUserList: [],
      markAsImportant: false,
      callingPendingAgents: null,
      transferMethodOptions: [],
      currentTransferMethod: 'user',
      currentTransferMethodDef: '',
      currentForwardingUser: null,
      transferedUser: null,
      partnerClientName: null,
      currentTransferPhoneNumber: null,
      displayName: '',
      reachHoldCountMaxAccepted: false,
      isReachTransferCountMax: false,
      parkHoldConfirm: false,
      //Modal
      modalMode: '',
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      modalSelectable: false,
      currentSavedMemo: '',
      countWordsMemo: 1000,
      countWordsSavedMemo: 0,
      loadMemoIntervalId: null,
      parkHoldIndex: null,
      sfContactAvailable: false,
      sfTable: null,
      sfAvailable: false,
      sfContactUnregistered: '<取引先責任者未登録>',
      memoAgentName: '',
      currentMemoHelp: '',
      maxMemoLength: 1000,
      telNumberListOptions: [{ label: '発信元番号選択', value: UNSELECTED }],
      selectedTelNumber: UNSELECTED,
      previousSelectedTelNumber: UNSELECTED,
      outgoingTelNumber: '',
      UNSELECTED, // be used in template scope
      using050Numbers: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers(
        'o-sf-calling-modal',
        `status-${this.callingStatus}`,
        this.fullscreenState ? 'fullscreen' : 'minimized'
      );
      return `${baseClassName} ${this.class}`.trim();
    },
    callingStatus() {
      if (this.isActive) {
        return 'active';
      } else if (this.isHolding || this.isParkHolding) {
        return 'onhold';
      } else if (this.isTransfer) {
        return 'transfer';
      }
      return this.status;
    },
    actionOnholdButtonClassName() {
      return mapModifiers('o-sf-calling-modal__onhold-button', this.isHolding ? 'activated' : '');
    },
    filteredPendingAvailableList() {
      return this.pendingAvailableList.filter(() => !this.isParkHolding);
    },
    shouldDisableHoldingButton() {
      return this.isTransfer || this.isParkHolding;
    },
    shouldDisableTransferButton() {
      return this.isHolding || this.isTransfer || this.isParkHolding;
    },
    shouldDisableNumpadButton() {
      return this.isHolding || this.isTransfer || this.isParkHolding;
    },
    shouldDisableParkHoldButton() {
      return this.isHolding || this.isTransfer;
    },
    isEnded() {
      return this.status === 'ended';
    },
    isReachHoldCountMax() {
      return this.reachHoldCountMaxAccepted && !this.isHolding;
    },
    isTrial() {
      return chkTrialCompanyID(this.$store.state.user.companyID);
    },
    myInfoList() {
      const ret = [];
      if (!this.telNumberInfo && !this.pushNumberSettingName && !this.outgoingTelNumber) return ret;

      if (this.telNumberInfo && this.telNumberInfo.telNumber) {
        // 着信時
        ret.push({ label: '自番号', value: this.telNumberInfo.telNumber });
      } else if (this.outgoingTelNumber) {
        // 発信時
        ret.push({ label: '自番号', value: this.outgoingTelNumber });
      }

      if (this.pushNumberSettingName) {
        ret.push({ label: 'プッシュ番号', value: this.collapseText(this.pushNumberSettingName, 10) });
      }
      return ret;
    },
  },
  watch: {
    isFullscreen(val) {
      this.fullscreenState = val;
    },
    microphone(val) {
      this.currentMicrophone = val;
    },
    speaker(val) {
      this.currentSpeaker = val;
    },
    memo(val) {
      this.currentMemo = val;
    },
    memoUpdated(val) {
      if (val) {
        this.loadMemo();
      }
    },
    status(val) {
      if (this.status === 'active') {
        this.isActive = true;
        this.isHolding = false;
        this.isTransfer = false;
        this.isParkHolding = false;
      } else if (this.status === 'onhold') {
        this.isActive = false;
        this.isHolding = true;
        this.isTransfer = false;
        this.isParkHolding = false;
      } else if (this.status === 'transfer') {
        this.isActive = false;
        this.isHolding = false;
        this.isTransfer = true;
        this.isParkHolding = false;
      } else if (this.status === 'holdexceed') {
        this.isActive = true;
        this.isHolding = false;
        this.isTransfer = false;
        this.isParkHolding = false;
      }
    },
    pendingActiveId(val) {
      this.callingPendingAgents = val;
    },
    currentMemo(val) {
      // メモ入力欄が空白か判断
      if (val.length === 0) {
        this.$emit('update-memo-empty-status', true);
      } else {
        this.$emit('update-memo-empty-status', false);
      }
      // 残り文字数カウント
      this.countWordsMemo = this.maxMemoLength - parseInt(val.length);
    },
    isAcw(val) {
      if (val === true) {
        this.handleGetSavedMemo();
      }
    },
    currentSavedMemo(val) {
      // 文字数カウント
      if (val) {
        this.countWordsSavedMemo = parseInt(val.length);
      }
    },
    isTransferActionOpened(val) {
      if (val) {
        this.fetchAvailableTelNumbers();
      }
    },
  },
  created() {
    this.$emit('update-client-list');
    if (this.customerInfo) {
      this.partnerClientName = this.getClientName(this.customerInfo.rawPhoneNumber);
    }
    this.fetchPreviousSelectedTelNumber();
    this.fetchOutgoingTelNumber();
  },
  async mounted() {
    this.postRequest('/contactlist/getcontactdata', {
      contactID: this.customerInfo.phoneNumber,
      companyID: this.companyID,
    })
      .then(parameters => {
        if (!parameters.data) {
          this.displayName = this.customerInfo.phoneNumber;
        } else {
          this.displayName = parameters.data.view_name;
        }
      })
      .catch(err => {
        console.log(err);
      });
    const vm = this;
    if (this.isFullscreen) {
      this.fullscreenState = this.isFullscreen;
    }
    if (this.memo) {
      this.currentMemo = this.memo;
    }
    if (this.microphone) {
      this.currentMicrophone = this.microphone;
    }
    if (this.speaker) {
      this.currentSpeaker = this.speaker;
    }
    if (this.pendingActiveId) {
      this.callingPendingAgents = this.pendingActiveId;
    }
    if (this.status === 'active') {
      this.isActive = true;
      this.isHolding = false;
      this.isTransfer = false;
      this.isParkHolding = false;
    } else if (this.status === 'onhold') {
      this.isActive = false;
      this.isHolding = true;
      this.isTransfer = false;
      this.isParkHolding = false;
    } else if (this.status === 'transfer') {
      this.isActive = false;
      this.isHolding = false;
      this.isTransfer = true;
      this.isParkHolding = false;
    }

    this.transferMethodOptions = this.getTransferMethodOptions(this.isTransferOk);
    this.currentTransferMethod = this.currentTransferMethodDef;

    new Simplebar(this.$el.querySelector('.o-sf-calling-modal__controls'));

    // 保存済みメモを読み込み
    this.postRequest('/callLogClient/getCallingMemo', {
      CallSid: this.currentCallSid,
      isExtensionCallOutbound: !this.isTransferOk,
    })
      .then(e => {
        if (e.data !== null && typeof e.data !== 'undefined') {
          if (e.data.length) {
            this.currentSavedMemo = e.data[0].memo;
          }
        }
      })
      .catch(err => {
        console.error(err);
      });

    await this.postRequest('/callLogClient/getSfPopupAvailable', {})
      .then(e => {
        if (e.status === 'success') {
          this.sfContactAvailable = e.data.companyInfo.sfContactAvailable;
          this.sfTable = e.data.companyInfo.sfTable;
          this.sfAvailable = e.data.companyInfo.sfAvailable;
        }
      })
      .catch(err => {
        console.error(err);
      });

    // 通話メモに追記するオペレータ名表示
    this.memoAgentName = '- ' + this.currentUserInfo.name + '\n';
    const memoAgentNameLength = this.memoAgentName.length;
    // 通話メモ欄のヘルプモーダル文言生成
    this.currentMemoHelp = messageContent.currentMemoHelpContent(this.memoAgentName);
    // 通話メモの最大文字数を設定
    this.maxMemoLength = 1000 - memoAgentNameLength;
    this.countWordsMemo = this.maxMemoLength;
  },
  methods: {
    loadMemo() {
      this.postRequest('/callLogClient/getCallingMemo', {
        CallSid: this.currentCallSid,
        isExtensionCallOutbound: !this.isTransferOk,
      })
        .then(e => {
          if (e.data !== null && typeof e.data !== 'undefined') {
            if (e.data.length) {
              this.currentSavedMemo = e.data[0].memo;
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    handleFullscreenButtonClick() {
      const vm = this;
      this.fullscreenState = true;
      this.$emit('update-calling-modal-fullscreen', true);
      // memo should scroll to the bottom
      //TODO: un comment when use memo later
      // this.$nextTick(() => {
      //   const textarea = this.$el.querySelector('.o-calling-model__memo-field .a-text-field__input');
      //   textarea.scrollTop = textarea.scrollHeight;
      // });
    },
    handleMinimizeButtonClick() {
      this.fullscreenState = false;
      this.$emit('update-calling-modal-fullscreen', false);
    },
    handleSettingActionButtonClick() {
      this.isSettingActionOpened = !this.isSettingActionOpened;
    },
    handleHoldActionButtonClick() {
      if (this.isHolding) {
        this.handleHoldActionButtonClickOK();
        return;
      }
      const self = this;
      this.postRequest('/hold/hold-count-check').then(data => {
        if (data.status !== 'success') {
          self.showErrorModal('保留中にエラーが発生しました。時間を空けて再度実行してください。');
          return;
        }
        if (data.isReached) {
          self.modalMode = 'hold';
          self.showInfoModal('これ以上の保留はできなくなりますが、よろしいですか？');
        } else {
          self.handleHoldActionButtonClickOK();
        }
      });
    },
    handleHoldActionButtonClickOK() {
      this.isHolding = !this.isHolding;
      if (this.isHolding) {
        this.isActive = false;
        this.isTransfer = false;
        this.isParkHolding = false;
      }
      this.handleHoldButtonClick(this.isHolding);
    },
    handleCallingPendingAgentActivated(id) {
      this.isTransfer = true;
      this.isActive = false;
      this.isHolding = false;
      this.isParkHolding = false;
      this.handleTransferAgentButtonClick(id);
    },
    handleCallingPendingAgentDectivated() {
      this.isTransfer = false;
      this.isActive = true;
      this.isHolding = false;
      this.isParkHolding = false;
      this.handleTransferAgentButtonClick(null);
    },
    handleTransferActionButtonClick() {
      this.isTransferActionOpened = !this.isTransferActionOpened;
    },
    handleNumpadActionButtonClick() {
      this.isNumpadActionOpened = !this.isNumpadActionOpened;
    },
    async handleEndCall() {
      await this.resetOutgoingTelNumber();
      this.handleEndCallButtonClick();
    },
    handleEndCallActionButtonClick() {
      this.isEndCallActionOpened = !this.isEndCallActionOpened;
    },
    handleCancelTransferNumberPopup() {
      this.currentTransferMethod = this.currentTransferMethodDef;
      this.currentForwardingUser = null;
      this.currentTransferPhoneNumber = '';
      this.isTransferActionOpened = false;
    },
    handleTransferCallPopupSubmit(e) {
      e.preventDefault();
      const self = this;

      if (self.currentTransferMethod === 'phone_number') {
        this.postRequest('/numbermgmt/getStockTelNumberInfo', {
          telNumber: self.currentUserInfo.phone_number.replace('0', '+81'),
        })
          .then(e => {
            if (e.data) {
              if (e.data.stockTelNumberInfo) {
                // 電話番号が利用停止の場合は外線転送不可
                if (e.data.stockTelNumberInfo.status === 'suspended') {
                  self.showErrorModal(
                    'ご利用の外線電話番号は利用停止中のため外線への転送ができません。電話番号のステータスを確認してください。'
                  );
                } else {
                  this.postRequest('/transfer/transfer-count-check').then(data => {
                    if (data.status !== 'success') {
                      self.showErrorModal('転送中にエラーが発生しました。時間を空けて再度実行してください。');
                      return;
                    }
                    if (data.isReached) {
                      self.modalMode = 'transfer';
                      self.showInfoModal('これ以上の転送はできなくなりますが、よろしいですか？');
                    } else {
                      self.handleTransferCall();
                    }
                  });
                }
              }
            }
          })
          .catch(err => {
            console.error(err);
          });
      } else {
        this.postRequest('/transfer/transfer-count-check').then(data => {
          if (data.status !== 'success') {
            self.showErrorModal('転送中にエラーが発生しました。時間を空けて再度実行してください。');
            return;
          }
          if (data.isReached) {
            self.modalMode = 'transfer';
            self.showInfoModal('これ以上の転送はできなくなりますが、よろしいですか？');
          } else {
            self.handleTransferCall();
          }
        });
      }
    },
    handleTransferCall() {
      const payload = {
        method: this.currentTransferMethod,
      };
      if (this.currentTransferMethod === 'user') {
        payload.user = this.currentForwardingUser;
        this.transferedUser = this.currentForwardingUser;
      } else if (this.currentTransferMethod === 'phone_number') {
        if (this.using050Numbers.includes(this.currentTransferPhoneNumber)) {
          this.showErrorModal(messageContent.notSetTransferNumber);
          return;
        }
        payload.phone_number = this.currentTransferPhoneNumber;
        payload.caller_number = this.selectedTelNumber;
        this.updatePreviousSelectedTelNumber(this.selectedTelNumber);
      }
      this.handleTransferCallSubmit(payload);
    },
    handleFormSubmit(e) {
      e.preventDefault();
      const payload = {
        memo: this.currentMemo,
        users: this.sharedUserList,
        important: this.markAsImportant,
      };
      this.handleEndFormSubmit(cloneDeep(payload));
    },
    handleOnholdActivated(val) {
      this.isParkHolding = !this.isParkHolding;
      this.handleOnholdActivateButtonClick(val);
    },
    handleOnholdDeactivated(val) {
      this.isParkHolding = !this.isParkHolding;
      this.handleOnholdDeactivateButtonClick(val);
    },
    checkMemoData: async function () {
      // 確認前に保存済みメモを読み込み
      await this.postRequest('/callLogClient/getCallingMemo', {
        CallSid: this.currentCallSid,
        isExtensionCallOutbound: !this.isTransferOk,
      })
        .then(e => {
          if (e.data !== null && typeof e.data !== 'undefined') {
            if (e.data.length) {
              this.currentSavedMemo = e.data[0].memo;
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
      const syncData = {};
      if (this.transferedUser) syncData[this.transferedUser] = true;
      if (this.partnerClientName) syncData[this.partnerClientName] = true;
      this.$emit('sync-memo', syncData);

      // 特殊文字チェック
      if (this.hasSpecialCharacterInString(this.currentMemo)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }
      if (this.hasSpecialCharacterInString(this.currentSavedMemo)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      let memoData = '';
      if (this.currentSavedMemo && !this.currentMemo) {
        // 過去メモあり・現在メモなしの場合、過去メモを保存する
        memoData = this.currentSavedMemo;
        this.handleSaveMemo(memoData);
        return;
      } else if (!this.currentSavedMemo && this.currentMemo) {
        // 過去メモなし・現在メモありの場合、現在メモを保存する
        memoData = this.memoAgentName + this.currentMemo;
        this.handleSaveMemo(memoData);
        return;
      } else if (!this.currentSavedMemo && !this.currentMemo) {
        // 過去メモなし・現在メモなしの場合、保存するメモデータなし
        memoData = '';
        this.handleSaveMemo(memoData);
        return;
      } else {
        // 過去メモあり・現在メモありの場合
        const mergedMemo = this.currentSavedMemo + '\n' + this.memoAgentName + this.currentMemo;
        if (mergedMemo.length > 1000) {
          this.modalMode = 'saveMemo';
          this.showInfoModal(messageContent.saveMemoMessage);
          return;
        } else {
          memoData = mergedMemo;
          this.handleSaveMemo(memoData);
          return;
        }
      }
    },
    saveNewMemo() {
      const memoData = '- ' + this.currentUserInfo.name + '\n' + this.currentMemo;
      this.handleSaveMemo(memoData);
    },
    savePreviousMemo() {
      const memoData = this.currentSavedMemo;
      this.handleSaveMemo(memoData);
    },
    async handleSaveMemo() {
      if (!this.hasSpecialCharacterInString(this.currentMemo)) {
        await this.postRequest('/callLogClient/saveCallingMemo', {
          CallSid: this.currentCallSid,
          Memo: this.currentMemo.replace(/\n/g, '%%n%%'),
          isExtensionCallOutbound: !this.isTransferOk,
        });
        const syncData = {};
        if (this.transferedUser) syncData[this.transferedUser] = true;
        if (this.partnerClientName) syncData[this.partnerClientName] = true;
        this.$emit('sync-memo', syncData);

        // Salesforce連携がONであればケースにメモを保存
        if (this.sfAvailable === true) {
          await this.postRequest('/callLogClient/updateSfCase', {
            CallSid: this.currentCallSid,
            createdCaseId: this.createdCaseId,
            Memo: this.currentMemo.replace(/\n/g, '%%n%%'),
            isExtensionCallOutbound: !this.isTransferOk,
            pageUrl: window.location.href,
          }).catch(err => {
            console.error(err);
          });
        }

        this.handleCloseCall();
      } else {
        this.showErrorModal(messageContent.hasSpecialCharacter);
      }
    },
    getTransferMethodOptions(flg) {
      const ret = [];
      if (flg === false) {
        if (!this.isTrial) {
          ret.push({ value: 'phone_number', label: '転送先電話番号を入力' });
          this.currentTransferMethodDef = 'phone_number';
        }
      } else {
        ret.push({ value: 'user', label: '転送先ユーザーを選択' });
        if (!this.isTrial) {
          ret.push({ value: 'phone_number', label: '転送先電話番号を入力' });
        }
        this.currentTransferMethodDef = 'user';
      }
      return ret;
    },
    handlePendingAgentsModal(type, message) {
      type === 'info' ? this.showInfoModal(message) : this.showErrorModal(message);
      this.modalMode = 'parkHold';
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    handleAcceptModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
      if (this.modalMode === 'hold') {
        this.handleHoldActionButtonClickOK();
        this.reachHoldCountMaxAccepted = true;
      } else if (this.modalMode === 'transfer') {
        this.isReachTransferCountMax = true;
        this.handleTransferCall();
      } else if (this.modalMode === 'parkHold') {
        this.parkHoldConfirm = true;
      }
    },

    handleGetSavedMemo() {
      // 保存済みメモを取得
      this.postRequest('/callLogClient/getCallingMemo', {
        CallSid: this.currentCallSid,
        isExtensionCallOutbound: !this.isTransferOk,
      })
        .then(e => {
          if (e.data !== null && typeof e.data !== 'undefined') {
            if (e.data.length) {
              this.currentSavedMemo = e.data[0].memo;
            }
          }
        })
        .catch(err => {
          console.error(err);
          this.showErrorModal('通話メモ取得中にエラーが発生しました。時間を空けて再度実行してください。');
        });
    },
    openCurrentMemoHelp() {
      this.showHelpModal(this.currentMemoHelp);
    },
    openPreviousMemoHelp() {
      this.showHelpModal(messageContent.previousMemoHelpContent);
    },
    showErrorModal(message) {
      this.modalSelectable = false;
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.modalSelectable = true;
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    showHelpModal(message) {
      this.modalSelectable = false;
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    getClientName(client) {
      if (!client || client.length < 36) return null;
      // Client is clientname
      if (client.length === 36) return client.replace(/_/g, '-');
      // Client format: "client:companyID-clientName"
      return client.replace('client:', '').slice(-36).replace(/_/g, '-');
    },
    fetchAvailableTelNumbers() {
      this.postRequest('/home/fetchAvailableTelNumbers')
        .then(res => {
          if (res.status === 'success') {
            const telNumbers = res.telNumbers;
            const telNumberListOptions = [{ label: '発信元番号選択', value: UNSELECTED }];
            const using050Numbers = [];
            let isSelectedNumberValid = false;
            for (const telNumber in telNumbers) {
              const label = telNumbers[telNumber] || '未設定';
              telNumberListOptions.push({ label: `${label}（${telNumber}）`, value: telNumber });
              if (telNumber === this.previousSelectedTelNumber) {
                isSelectedNumberValid = true;
              }
              using050Numbers.push(telNumber);
            }
            this.telNumberListOptions = telNumberListOptions;
            this.using050Numbers = using050Numbers;
            this.selectedTelNumber = isSelectedNumberValid ? this.previousSelectedTelNumber : UNSELECTED;
          } else {
            this.telNumberListOptions = [{ label: '発信元番号選択', value: UNSELECTED }];
            this.selectedTelNumber = UNSELECTED;
            throw new Error('Fetch data failed');
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchPreviousSelectedTelNumber() {
      this.postRequest('/home/fetchPreviousSelectedTelNumber')
        .then(res => {
          if (res.status === 'success') {
            this.previousSelectedTelNumber = res.previousSelectedTelNumber || UNSELECTED;
            if (this.previousSelectedTelNumber !== UNSELECTED) {
              this.telNumberListOptions.push({ label: 'ダミー', value: this.previousSelectedTelNumber });
            }
          } else {
            throw new Error('Fetch data failed');
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    updatePreviousSelectedTelNumber(from) {
      this.postRequest('/home/updatePreviousSelectedTelNumber', {
        previousSelectedTelNumber: from,
      })
        .then(res => {
          if (res.status === 'success') {
            return;
          } else {
            throw new Error('Update data failed');
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    fetchOutgoingTelNumber() {
      this.postRequest('/home/fetchOutgoingTelNumber')
        .then(res => {
          if (res.status === 'success') {
            this.outgoingTelNumber = res.outgoingTelNumber;
          } else {
            throw new Error('Fetch outgoing telNumber data failed');
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    resetOutgoingTelNumber() {
      this.postRequest('/home/updateOutgoingTelNumber', {
        outgoingTelNumber: '',
      })
        .then(res => {
          if (res.status === 'success') {
            return;
          } else {
            throw new Error('Reset outgoingTelNumber data failed');
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
};
</script>
